import React from 'react'
import ResetZoomButton from './ResetZoomButton'

const ParamResetSelector = ({
    resetExpanded,
    resetZoomFunction,
    resetParamsFunction,
}) => {
    if (!resetExpanded) {
        return null
    }
    return (
        <div className="timeWindowDropdownWrapper">
            <ResetZoomButton resetFunction={resetZoomFunction} isInDropdown={true}/>
            <div
                className="panelButton timeWindowOptionWrapper"
                onClick={() => resetParamsFunction()}
            >
                <span className="timeWindowOptionText">Reset Parameters</span>
            </div>
        </div>        
    )
}

export default ParamResetSelector